import { clsx } from 'clsx'
import { type FC } from 'react'

import { ExperimentStockInformation } from '../../../../../experiments/components/ExperimentStockInformation/ExperimentStockInformation'
import { useGetExperiment } from '../../../../../experiments/hooks'
import {
  EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS,
  EXPERIMENT_NAME_PDP_STOCK_INFORMATION,
} from '../../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../../experiments/model/EXPERIMENT_VARIATION'
import { experimentAccessorNonDefault } from '../../../../../experiments/model/experimentAccessor'
import { productAccessorIsSaeOffer } from '../../../../model/productAccessor/productAccessorIsSaeOffer'
import { useProductPageContext } from '../../../productPageContext'
import { useProductStockStatus } from '../../hooks/useProductStockStatus'

export const ProductBuyBoxStockStatus: FC = () => {
  const productStockStatus = useProductStockStatus()

  const stockInformationExperiment = useGetExperiment(
    EXPERIMENT_NAME_PDP_STOCK_INFORMATION,
  )

  const pdpDeliveryOptions = useGetExperiment(
    EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS,
  )

  const { currentOffer } = useProductPageContext()

  const isMarketplace = currentOffer
    ? !productAccessorIsSaeOffer(currentOffer)
    : false

  if (
    experimentAccessorNonDefault(stockInformationExperiment) &&
    currentOffer &&
    productAccessorIsSaeOffer(currentOffer)
  ) {
    return (
      <ExperimentStockInformation
        experimentVariation={stockInformationExperiment.variant}
      />
    )
  }

  return (
    <span
      className={
        pdpDeliveryOptions.isEnabled &&
        !isMarketplace &&
        pdpDeliveryOptions.variant !== EXPERIMENT_VARIATION.DEFAULT
          ? 'text-s text-dark-primary-max'
          : clsx('font-medium', productStockStatus.color)
      }
      data-qa-id="product-status-qa-id"
    >
      {productStockStatus.message}
    </span>
  )
}
